"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// TODO: get the correct SVG
var Star = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 16 : _b, _c = _a.width, width = _c === void 0 ? 16 : _c, rest = __rest(_a, ["height", "width"]);
    return (react_1["default"].createElement("svg", __assign({ viewBox: "0 0 8 8" }, rest),
        react_1["default"].createElement("path", { d: "M3.67444 0.212345L2.63552 2.41511L0.312205 2.7684C0.0139737 2.81375 -0.105114 3.19732 0.110683 3.41748L1.79181 5.13257L1.39507 7.55424C1.34414 7.86508 1.65586 8.10212 1.92259 7.9554L4.00049 6.81247L6.07838 7.9554C6.34512 8.10212 6.65683 7.86508 6.60591 7.55424L6.20916 5.13257L7.89029 3.41748C8.10609 3.19732 7.987 2.81375 7.68877 2.7684L5.36545 2.41511L4.32653 0.212345C4.19315 -0.0704562 3.80782 -0.0704562 3.67444 0.212345Z" })));
};
exports["default"] = Star;
